import axios, {
  type AxiosPromise,
  type Axios,
  type AxiosError,
  type AxiosResponse,
  type AxiosRequestConfig,
} from "axios";
import { cookieStorage } from "wagmi";
import { COOKIE_KEY } from "~/src/constants/cookie";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export interface MyAxiosInstance extends Axios {
  (config: AxiosRequestConfig): AxiosPromise;
  (url: string, config?: AxiosRequestConfig): AxiosPromise;
}

const authorizedUpload: MyAxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

authorizedUpload.interceptors.request.use(
  (config) => {
    const newConfig = { ...config };
    const token = cookieStorage.getItem(COOKIE_KEY.accessToken);
    if (!token) {
      // Cancel the request if there is no token
      throw new Error("No token available");
    } else {
      newConfig.headers.Authorization = `Bearer ${token}`;
    }
    return newConfig;
  },
  async function (error) {
    return await Promise.reject(error);
  }
);

authorizedUpload.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  async (error: AxiosError) => {
    return await Promise.reject(error.response?.data ?? error);
  }
);

export default authorizedUpload;
